import moment from 'moment';
import { getUserBookReport, getUserReportDownLoad } from '../services/report';
import { getZoneTreeData } from '../services/calender';

export default {
  namespace: 'userReport',
  state: {
    deptName: '',
    deptId: '',
    startTime: moment()
      .startOf('day')
      .valueOf(),
    endTime: moment()
      .endOf('day')
      .valueOf(),
    bookName: '',
    pageNo: 1,
    pageSize: 10,
    searchData: [],
    meetingTreeData: { child: [] },
    meetingSearchInfo: {
      meetingType: undefined,
      meetingDevice: undefined,
      moreMeeting: []
    },
    dropVis: false,
    userAllMoreMenu: [
      'main_meeting_time_length',
      'main_meeting_attends_list',
      'main_room_capacity',
      'main_meeting_sign_rate',
      'report_roomDetail_unSignNames',
      'main_meeting_disuse',
      'report_abnormal_extend',
      'report_abnormal_early_end',
      'resource_name_meeting_type',
      're_cycle_meeting'
    ],
    indeterminate: false,
    checkAll: false,
    moreMenu: [],
    checkMenu: []
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    },
    setMeetingTreeData(state, { meetingTreeData }) {
      return { ...state, meetingTreeData };
    }
  },
  effects: {
    *search(undefined, { call, select, put }) {
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.userReport.startTime);
      let endTime = yield select(state => state.userReport.endTime);
      let userName = yield select(state => state.userReport.bookName);
      let deptId = yield select(state => state.userReport.deptId);
      let meetingSearchInfo = yield select(
        state => state.userReport.meetingSearchInfo
      );
      let pageNo = yield select(state => state.userReport.pageNo);
      let pageSize = yield select(state => state.userReport.pageSize);
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      let data = yield call(getUserBookReport, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        creatorNames: userName,
        deptIds: deptId,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *changePage({ payload }, { call, select, put }) {
      yield put({ type: 'setState', payload: { ...payload } });
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.userReport.startTime);
      let endTime = yield select(state => state.userReport.endTime);
      let userName = yield select(state => state.userReport.bookName);
      let deptId = yield select(state => state.userReport.deptId);
      let meetingSearchInfo = yield select(
        state => state.userReport.meetingSearchInfo
      );
      let pageNo = yield select(state => state.userReport.pageNo);
      let pageSize = yield select(state => state.userReport.pageSize);
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      let data = yield call(getUserBookReport, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        creatorNames: userName,
        deptIds: deptId,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *downloadUser({}, { select, call }) {
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.userReport.startTime);
      let endTime = yield select(state => state.userReport.endTime);
      let userName = yield select(state => state.userReport.bookName);
      let deptId = yield select(state => state.userReport.deptId);
      let meetingSearchInfo = yield select(
        state => state.userReport.meetingSearchInfo
      );
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      yield call(getUserReportDownLoad, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        creatorNames: userName,
        deptIds: deptId,
        locale,
        token
      });
    },
    *getMeetingTreeDataForSearch({}, { select, put, call }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getZoneTreeData, {
        pageNo: '',
        pageSize: '',
        startTime: moment()
          .startOf('day')
          .valueOf(),
        endTime: '',
        flag: 3,
        otherRoomIds: '',
        audit: '',
        name: '',
        deviceIds: '',
        teaIds: '',
        lang: locale
      });
      yield put({ type: 'setMeetingTreeData', meetingTreeData: data.data });
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname.indexOf('userReport') > -1) {
          dispatch({ type: 'getMeetingTreeDataForSearch' });
          let p = {
            startTime: moment().subtract(1, 'days'),
            endTime: moment().subtract(1, 'days'),
            bookName: '',
            pageNo: 1,
            pageSize: 10,
            searchData: [],
            meetingTreeData: { child: [] },
            meetingSearchInfo: {
              meetingType: undefined,
              meetingDevice: undefined,
              moreMeeting: []
            }
          };
          dispatch({ type: 'setState', payload: p });
        } else if (
          pathname.indexOf('userAbnormallyReport') !== -1 ||
          pathname.indexOf('userReport') !== -1
        ) {
          dispatch({
            type: 'account/getAllDept'
          });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/userReport.js